export default __webpack_public_path__ + "static/media/bg4.1967b252.png";